module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('marker', {
    attrs: {
      "id": _vm.markerId,
      "viewBox": "0 0 10 10",
      "refX": "9",
      "refY": "5",
      "markerUnits": "strokeWidth",
      "markerWidth": "10",
      "markerHeight": "10",
      "orient": "auto-start-reverse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 0 0 L 10 5 L 0 10 z",
      "fill": _vm.color
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": _vm.x,
      "x2": _vm.x2,
      "y1": _vm.y,
      "y2": _vm.y2,
      "stroke": _vm.color,
      "marker-end": ("url(#" + _vm.markerId + ")"),
      "marker-start": ("url(#" + _vm.markerId + ")")
    }
  }), _vm._v(" "), (_vm.isVerticalPlan) ? _c('g', [_c('line', {
    attrs: {
      "x1": _vm.indicatorX,
      "x2": _vm.from.x,
      "y1": _vm.y,
      "y2": _vm.from.y,
      "stroke": _vm.color
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": _vm.indicatorX,
      "x2": _vm.from.x,
      "y1": _vm.y2,
      "y2": _vm.to.y,
      "stroke": _vm.color
    }
  }), _vm._v(" "), _c('foreignObject', {
    attrs: {
      "width": "105",
      "height": "23",
      "transform": ("translate(" + (_vm.indicatorX - 18 * _vm.axisCoef) + "," + ((_vm.y + _vm.y2) / 2 + 25 * _vm.axisCoef) + ")rotate(" + (-90 * _vm.axisCoef) + ")")
    }
  }, [_c('div', {
    attrs: {
      "xmlns": "http://www.w3.org/1999/xhtml"
    }
  }, [(!_vm.disabled) ? _c('NumberInput', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function (e) { return _vm.$emit('input', e); }
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.value.toFixed(2)))]), _vm._v("  mm\n            ")], 1)])], 1) : _c('g', [_c('line', {
    attrs: {
      "x1": _vm.from.x,
      "x2": _vm.x,
      "y1": _vm.indicatorY,
      "y2": _vm.from.y,
      "stroke": _vm.color
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": _vm.to.x,
      "x2": _vm.x2,
      "y1": _vm.indicatorY,
      "y2": _vm.to.y,
      "stroke": _vm.color
    }
  }), _vm._v(" "), _c('foreignObject', {
    attrs: {
      "width": "105",
      "height": "23",
      "transform": ("translate(" + ((_vm.x + _vm.x2) / 2 - 25) + ", " + (_vm.indicatorY - 18 * _vm.axisCoef) + ")")
    }
  }, [_c('div', {
    attrs: {
      "xmlns": "http://www.w3.org/1999/xhtml"
    }
  }, [(!_vm.disabled) ? _c('NumberInput', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function (e) { return _vm.$emit('input', e); }
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.value.toFixed(2)))]), _vm._v("  mm\n            ")], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e313a71","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/components/size-arrow.vue
// module id = 3254
// module chunks = 0